import React from 'react'
import { useTranslation } from 'react-i18next'
import Progress from '../../../components/Progress'
import TrialOverBanner from './TrialOverBanner/TrialOverBanner'
import moment from 'moment'

const TrialProgressBanner = ({ startDate, expirationDate, isVisible }) => {
    const { t } = useTranslation()
    const currentDate = moment()
    const numberOfDaysPassed = moment(currentDate).diff(startDate, 'days')
    const totalNumberOfDays = moment(expirationDate).diff(startDate, 'days')
    const numberOfDaysLeft = totalNumberOfDays - numberOfDaysPassed
    const isExpired = moment(expirationDate).diff(currentDate.valueOf()) <= 0

    if (!isVisible) return null

    return (
        <div>
            {!isExpired ? (
                <Progress
                    value={numberOfDaysPassed > 0 ? numberOfDaysPassed : 0.1} // тонкая начальная полоска, чтобы не выглядело неактивно
                    total={totalNumberOfDays}
                    title={t('{{totalNumberOfDays}}-days trial period', { totalNumberOfDays })}
                    formattedTextResult={t('{{count}} days left', { count: numberOfDaysLeft })}
                />
            ) : (
                <TrialOverBanner t={t} />
            )}
        </div>
    )
}

export default TrialProgressBanner
